export enum unitsMapping {
  'kg/cm' = 1,
  'lb/ftin' = 2,
}

export enum measurementType {
  weight = 1,
  height = 2,
  inch = 3,
}

export enum returnedTypes {
  value = 1,
  unit = 2,
  both = 3,
}
